import axios from "axios";
import { API } from "../config";
import { setupInterceptors } from "./interceptors";

const client = axios.create({
    baseURL: API.BASE_URL,
    withCredentials: true,
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

setupInterceptors(client);

export default client;